import type { Component } from "solid-js";
import { Badge } from "@/components/ui/badge";

export const SkillBadge: Component<{
  skill: string;
  class?: string;
}> = (props) => {
  return (
    <Badge variant="skill" size="sm" class={props.class}>
      {props.skill}
    </Badge>
  );
};
